<template>
  <div class="report-section report-section-monitor-overview">
    <div v-if="reportData.options?.name || reportData.name" class="section-title">{{ reportData.options?.name || reportData.name }}</div>
    <div v-if="reportData.options?.description || reportData.description" class="section-description">{{ reportData.options?.description || reportData.description }}</div>
    <monitor-overview ref="template" :is-template="true" :is-template-edit="isTemplateEdit" :template-params="reportData.queryParams || reportData.options?.queryParams" :scopeParams="scopeParams" />
  </div>
</template>

<script>
import MonitorOverview from '@Monitor/views/overview/components/index'
export default {
  name: 'ReportMonitorOverview',
  components: {
    MonitorOverview,
  },
  props: {
    reportData: {
      type: Object,
      default: () => ({}),
    },
    scopeParams: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style lang="less" scoped>
.section-title {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 5px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.5);
  margin-bottom: 15px;
}
.section-description {
  color: #666;
  font-size: 14px;
  margin-bottom: 15px;
}
</style>
